import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useAuth } from 'react-oidc-context';
import TemplateDetailModal from './TemplateDetailModal';
import { ButtonBase, CircularProgress, Grid, IconButton, ThemeProvider, createTheme, styled } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import SessionExpiredModal from '../../utils/SessionExpiredModal';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { formatDatetime, PaginationNavigation } from '../../utils/funtions';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { TextButton, darkTheme } from '../../utils/funtions';
import CreateWorkpaperTemplate from './CreateWorkpaperTemplate';

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  'position': 'relative',
  'borderRadius': '0.5vw',
  'transition': '0.1s',
  '&:hover, &.Mui-focusVisible': {
    'zIndex': 1,
    'backgroundColor': 'rgb(255, 255, 255, 0.05)',
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      border: '4px solid currentColor',
    },
  },
}));

function WorkpaperTemplateSettings() {
  const labels = [
    'General Ledger',
    'Balance Sheet',
    'Profit & Loss',
    'Wages',
    'Wages PAS',
    'Debtor',
    'Creditor',
    'Interest & Penalty',
    'Income Tax Statement (IT)',
    'Integrated Client Account (AS)',
    'GST',
    'GST Rec',
    'FR ACC',
  ];

  const auth = useAuth();

  const [
    tabData,
    setTabData,
  ] = useState([]);

  const [
    detailModalShown,
    setDetailModalShown,
  ] = useState(false);

  const [
    currentTemplateId,
    setCurrentTemplateId,
  ] = useState('');

  const [
    currentTemplate,
    setCurrentTemplate,
  ] = useState('');

  const [
    currentCustomName,
    setCurrentCustomName,
  ] = useState('');

  const [
    isLoading,
    setIsLoading,
  ] = useState(true);

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const [
    createTemplateShow,
    setCreateTemplateShow,
  ] = useState(false);

  function closeDetailModalHandler() {
    setDetailModalShown(false);
  }

  const [
    isEditing,
    setIsEditing,
  ] = useState(false);
  const [
    selectAll,
    setSelectAll,
  ] = useState(false);
  const [
    checkedItems,
    setCheckedItems,
  ] = useState(
    labels.reduce((acc, label) => {
      acc[label] = false;
      return acc;
    }, {}),
  );

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setCheckedItems(
      labels.reduce((acc, label) => {
        acc[label] = !selectAll;
        return acc;
      }, {}),
    );
  };

  const handleChange = (label) => {
    setCheckedItems((prevState) => {
      const newCheckedItems = { ...prevState, [label]: !prevState[label] };
      const allSelected = labels.every(l => newCheckedItems[l]);
      setSelectAll(allSelected);
      return newCheckedItems;
    });
  };

  const [
    tableData,
    setTableData,
  ] = useState(tabData);

  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);
  const itemsPerPage = 5;

  let indexOfLastItem = currentPage * itemsPerPage;
  let indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const [
    currentItems,
    setCurrentitems,
  ] = useState(tabData.slice(indexOfFirstItem, indexOfLastItem));

  // Page change handlers
  const nextPage = () => {
    if (currentPage < Math.ceil(tableData.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const fetchData = () => {
    if (auth.user?.profile.accountant.ssid) {
      console.log('execute');
      fetch(`${window.origin}/api/creator/template`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      }).then((data) => {
        setTabData(data);
        setIsLoading(false);
      }).catch((error) => {
        console.error(error);
      });
    }
  };

  const handleOpenCreateTemplate = () => {
    setCreateTemplateShow(true);
  };

  useEffect(() => {
    setTableData(tabData);
    console.log(tabData);
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(tabData.slice(indexOfFirstItem, indexOfLastItem));
  }, [tabData]);

  useEffect(() => {
    // Calculate the items for the current page
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setCurrentitems(tabData.slice(indexOfFirstItem, indexOfLastItem));
  }, [currentPage]);

  useEffect(() => {
    fetchData();
  }, [auth.user?.profile.accountant.ssid]);

  return (
    <>
      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Create and modify your workpaper templates
      </p>
      <CreateWorkpaperTemplate show={createTemplateShow} onHide={() => { setCreateTemplateShow(false); }} onRefresh={fetchData} />
      <SessionExpiredModal show={sessionExpired} />
      <div style={{ padding: '0 2.5vw' }}>

        <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.5vw', width: '15vw', marginBottom: '1.5vw', width: '100%' }}>

          <div style={{ visibility: 'hidden', backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '0.8vw', padding: '0.5vw', paddingLeft: '1vw', width: '15vw', color: 'rgb(0, 15, 30, 0.7)' }}>
            <ThemeProvider theme={darkTheme}>

              <SearchIcon style={{ fontSize: '1vw' }} />
            </ThemeProvider>

            <Form.Control
              id="client-search-bar"
              style={{
                display: 'inline', backgroundColor: 'rgba(255,255,255,0)', padding: 0, paddingLeft: '0.5vw',
                border: '1px solid rgb(254, 254, 255, 0)', borderRadius: '6px', fontSize: '0.9vw', maxWidth: '80%', marginLeft: '0', fontWeight: '200',
              }}
              className="shadow-none"
              type="text"
              placeholder="Search"
              // value={searchTerm}
              // onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
          <div style={{ flex: 1, textAlign: 'right', paddingLeft: '0.5vw' }}>

            <OverlayTrigger
              key="top-submit"
              placement="top"
              overlay={(
                <Tooltip id="tooltip-submit">
                  Create Request
                </Tooltip>
              )}
            >
              <TextButton id="create-new-workpaper" variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.7)', marginLeft: '1vw' }} onClick={handleOpenCreateTemplate}>
                <i className="fa-solid fa-plus" style={{ fontSize: '0.9vw', width: '0.95vw', height: '0.95vw' }}></i>
              </TextButton>

            </OverlayTrigger>
          </div>

        </div>

        <div style={{ margin: '0.5vw 0', marginTop: '0', padding: 0, fontSize: '1.6rem', borderRadius: '5vw' }}>
          <div style={{ width: '100%', textAlign: 'left' }}>
            <Grid container spacing={2}>
              { currentItems.map((row, index) => {
                return (
                  <Grid item xs={6} key={index} spacing={1}>
                    <ButtonBase focusRipple style={{ width: '100%', textAlign: 'left', borderRadius: '1.2vw', color: 'rgb(0, 0, 0, 0.6)' }}>
                      <div
                        style={{ width: '100%', backgroundColor: 'rgb(254, 254, 255, 0.8)', borderRadius: '1vw', cursor: 'pointer', border: '0.05vw solid rgb(254, 254, 255, 0)' }}
                        onClick={() => {
                          console.log(row);
                          setCurrentTemplate(row);
                          setCurrentTemplateId(row.id);
                          setDetailModalShown(true);
                        }}
                      >
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                          <IconButton style={{ margin: '1vw', boxShadow: 'inset 0 0 1vw rgb(0, 0, 0, 0.07)' }} disabled>
                            <ContentCopyIcon style={{ margin: '0.5vw', fontSize: '1.7vw', color: 'rgb(0, 15, 30, 0.8)' }} />
                          </IconButton>
                          <div style={{ flex: 1, padding: '0.5vw', paddingLeft: '0' }}>
                            <p style={{ fontSize: '0.9vw', margin: 0, lineHeight: '1.5vw', fontWeight: '600', color: 'rgb(0, 15, 30, 0.7)' }}>{row.name}</p>
                            <p style={{ fontSize: '0.75vw', lineHeight: '1.5vw', margin: 0, fontWeight: '400', color: 'rgb(0, 15, 30, 0.4)' }}>
                              Last Modified:
                              {formatDatetime(row.lastModified)}
                            </p>
                          </div>
                        </div>
                        {/* <div style={{padding: '1.3vw', paddingTop: '0'}}>
                                                <p style={{fontSize: '0.8vw', lineHeight: '1.5vw', margin: 0, fontWeight: '500', color: 'rgb(255, 255, 255, 0.9)'}}><span style={{color: 'rgb(255, 255, 255, 0.6)'}}>Period:</span> {period}</p>
                                                <p style={{fontSize: '0.8vw', lineHeight: '1.5vw', margin: 0, fontWeight: '500', color: 'rgb(255, 255, 255, 0.85)'}}><span style={{color: 'rgb(255, 255, 255, 0.6)'}}>Latest Version:</span> {row.latest_version}</p>

                                            </div> */}
                      </div>
                    </ButtonBase>
                  </Grid>
                );
              })}
            </Grid>

            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1vw', marginRight: '0.5vw', marginLeft: '0.5vw', marginBottom: '0.5vw' }}>
              <div style={{ flex: 1, alignSelf: 'center' }}>
                <p style={{ color: 'rgb(0,15,30, 0.6)', fontSize: '0.85vw', marginLeft: '0.5vw', marginBottom: 0, textAlign: 'left' }}>
                  Showing
                  {indexOfFirstItem + 1}
                  {' '}
                  to
                  {indexOfLastItem > tableData.length ? tableData.length : indexOfLastItem}
                  {' '}
                  of
                  {tableData.length}
                  {' '}
                  entries
                </p>
              </div>

              {/* arrow buttons */}
              <PaginationNavigation onNextPage={nextPage} onPrevPage={prevPage} />

            </div>
          </div>
        </div>

      </div>
      <TemplateDetailModal show={detailModalShown} onClose={closeDetailModalHandler} tabId={currentTemplateId} template={currentTemplate} customName={currentCustomName} fetchDataHandler={fetchData} />
    </>
  );
}

export default WorkpaperTemplateSettings;
